import * as angular from "angular";
import {IController} from 'angular';
import {JobsGroupByEnum} from "../../types/jobs-group-by.enum";

export class PlanningJobsGroupTypeFilterComponent implements IController {

  groupByType: JobsGroupByEnum;
  onChange: Function;

  constructor(private $mdPanel) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-selection-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const groupByTypeRef = this.groupByType;
    const optionsRef = Object.values(JobsGroupByEnum);

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.groupByTypeRef" ' +
        'options="ctrl.optionsRef" ' +
        'options-prefix="JOBS_GROUP_BY_TYPES" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'custom';
        this.groupByTypeRef = groupByTypeRef;
        this.optionsRef = optionsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        panel.destroy();
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          return;
        } else {
          this.onChange({selectedGroupByType: selectedId});
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedGroupByType: undefined});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningJobsGroupTypeFilter', {
    bindings: {
      groupByType: '<',
      onChange: '&'
    },
    template: require('./planning-jobs-group-type-filter.html').default,
    controller: PlanningJobsGroupTypeFilterComponent
  });
